/* Response Time CSS */

export default theme => ({
    root: {},
    sizeDivider:{
        height:"3px"
    },
    back:{
        backgroundColor:"rgb(27,27,27)"
    },
    gridItem:{
        paddingRight:"32px"
    },
    textField:{
        transform: "translate(0px, -7px) scale(1)",
        fontSize: "13px"
    },
    contentCircular:{
        textAlign:"center", 
        //backgroundColor:"black"
    },
    circular:{
        //color:"white"
    },
    infoText:{
        color: "gray",
        fontSize: "12px"
    },
    rem:{
        fontSize:"1.01rem"
    }

})